import {FILTERS_CONFIG_VINO} from 'plugins/modules/filter/constants/filterGroups/vino/filtersConfig';
import {IFilterFacet} from 'plugins/modules/filter/types';

interface IAddGroupItemProps {
    data: IFilterFacet;
    groupSearchPlaceholder?: string;
    groupTitle?: string;
    groupWithCollapse?: boolean;
    groupWithSearch?: boolean;
    itemWithCollapse?: boolean;
    itemWithSearch?: boolean;
}

interface IGroupListItem {
    data: IFilterFacet;
    itemWithCollapse?: boolean;
    itemWithSearch?: boolean;
}

export interface IGroupItem {
    groupList: IGroupListItem[];
    groupSearchPlaceholder?: string;
    groupTitle: string;
    groupWithCollapse?: boolean;
    groupWithSearch?: boolean;
}

export class GroupFacetFilters {
    constructor(filters: IFilterFacet[]) {
        this.filters = [...filters];

        this.init();
    }

    private filters: IFilterFacet[];
    groupedFilters: IGroupItem[] = [];

    private addGroupItem = ({
        data,
        groupSearchPlaceholder = '',
        groupTitle = '',
        groupWithCollapse = false,
        groupWithSearch = false,
        itemWithCollapse = true,
        itemWithSearch = true,
    }: IAddGroupItemProps) => {
        const groupData = {
            groupList: [
                {
                    data,
                    itemWithCollapse,
                },
            ],
            groupSearchPlaceholder,
            groupTitle,
            groupWithCollapse,
            groupWithSearch,
            itemWithSearch,
        };

        this.groupedFilters.push(groupData);
    };

    private init = () => {
        this.sort();

        this.filters.forEach((filterItem) => {
            const {code} = filterItem;

            const config = FILTERS_CONFIG_VINO.find((configItem) => configItem.code === code);

            if (!config) {
                this.addGroupItem({data: filterItem});

                return;
            }

            const {group, itemWithCollapse, itemWithSearch} = config;

            if (!group) {
                this.addGroupItem({data: filterItem, itemWithCollapse, itemWithSearch});

                return;
            }

            const {title, groupSearchPlaceholder, groupWithCollapse, withSearch} = group;

            const currentGroup = this.groupedFilters.find((item) => item.groupTitle === title);

            if (!currentGroup) {
                this.addGroupItem({
                    data: filterItem,
                    groupSearchPlaceholder,
                    groupTitle: title,
                    groupWithCollapse,
                    groupWithSearch: withSearch,
                    itemWithCollapse,
                    itemWithSearch,
                });

                return;
            }

            currentGroup.groupList.push({
                data: filterItem,
                itemWithCollapse,
                itemWithSearch,
            });
        });
    };

    private sort = () => {
        this.filters.sort((a, b) => {
            return a.sort - b.sort;
        });
    };
}
